module.exports = __webpack_public_path__ + "img/IT0000128168984.d596ff40.png";